/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "../models";
import * as Mappers from "../models/farmapromPharmacyMappers";
import * as Parameters from "../models/parameters";
import { PolandPharmacyRxAPIContext } from "../polandPharmacyRxAPIContext";

/** Class representing a FarmapromPharmacy. */
export class FarmapromPharmacy {
  private readonly client: PolandPharmacyRxAPIContext;

  /**
   * Create a FarmapromPharmacy.
   * @param {PolandPharmacyRxAPIContext} client Reference to the service client.
   */
  constructor(client: PolandPharmacyRxAPIContext) {
    this.client = client;
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<Models.FarmapromPharmacyAllResponse>
   */
  all(options?: Models.FarmapromPharmacyAllOptionalParams): Promise<Models.FarmapromPharmacyAllResponse>;
  /**
   * @param callback The callback
   */
  all(callback: msRest.ServiceCallback<Models.FarmapromPharmacyDtoPagedResult>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  all(options: Models.FarmapromPharmacyAllOptionalParams, callback: msRest.ServiceCallback<Models.FarmapromPharmacyDtoPagedResult>): void;
  all(options?: Models.FarmapromPharmacyAllOptionalParams | msRest.ServiceCallback<Models.FarmapromPharmacyDtoPagedResult>, callback?: msRest.ServiceCallback<Models.FarmapromPharmacyDtoPagedResult>): Promise<Models.FarmapromPharmacyAllResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      allOperationSpec,
      callback) as Promise<Models.FarmapromPharmacyAllResponse>;
  }

  /**
   * @param id
   * @param [options] The optional parameters
   * @returns Promise<Models.FarmapromPharmacyGetByIdResponse>
   */
  getById(id: string, options?: msRest.RequestOptionsBase): Promise<Models.FarmapromPharmacyGetByIdResponse>;
  /**
   * @param id
   * @param callback The callback
   */
  getById(id: string, callback: msRest.ServiceCallback<Models.FarmapromPharmacyDto>): void;
  /**
   * @param id
   * @param options The optional parameters
   * @param callback The callback
   */
  getById(id: string, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.FarmapromPharmacyDto>): void;
  getById(id: string, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.FarmapromPharmacyDto>, callback?: msRest.ServiceCallback<Models.FarmapromPharmacyDto>): Promise<Models.FarmapromPharmacyGetByIdResponse> {
    return this.client.sendOperationRequest(
      {
        id,
        options
      },
      getByIdOperationSpec,
      callback) as Promise<Models.FarmapromPharmacyGetByIdResponse>;
  }
}

// Operation Specifications
const serializer = new msRest.Serializer(Mappers);
const allOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "farmapromPharmacy/FarmapromPharmacy",
  queryParameters: [
    Parameters.filters,
    Parameters.sorts,
    Parameters.page,
    Parameters.pageSize
  ],
  responses: {
    200: {
      bodyMapper: Mappers.FarmapromPharmacyDtoPagedResult
    },
    default: {}
  },
  serializer
};

const getByIdOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "farmapromPharmacy/FarmapromPharmacy/{id}",
  urlParameters: [
    Parameters.id1
  ],
  responses: {
    200: {
      bodyMapper: Mappers.FarmapromPharmacyDto
    },
    default: {}
  },
  serializer
};
